module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-mlk-right-ba5f17001fe938a46bd5409988f7c15f.svg";